import { useState, useCallback } from 'react';
import { SearchResult } from '../types';
import { smartSearch } from '../utils/dataProcessor';

export const useSearch = () => {
  const [searchInput, setSearchInput] = useState('');
  const [searchResult, setSearchResult] = useState<SearchResult | null>(null);
  const [isSearching, setIsSearching] = useState(false);

  const performSearch = useCallback(async (input: string) => {
    if (!input.trim()) return null;

    setIsSearching(true);

    try {
      const result = await smartSearch(input);
      setSearchResult(result);
      return result;
    } catch (error) {
      const errorResult = { found: false };
      setSearchResult(errorResult);
      return errorResult;
    } finally {
      setIsSearching(false);
    }
  }, []);

  const clearSearch = useCallback(() => {
    setSearchInput('');
    setSearchResult(null);
  }, []);

  return {
    searchInput,
    setSearchInput,
    searchResult,
    isSearching,
    performSearch,
    clearSearch,
  };
};
